'use strict';

export default function RtbPixelService(CreativeService, $http, $q) {
  var vm = this;
  vm.create = create;
  vm.get = get;
  vm.findOrCreate = findOrCreate;
  vm.reset = reset;
  vm.pixelKey = null;
  vm.errors = null;

  function findOrCreate() {
    if (vm.pixelKey) {
      return $q.resolve();
    }

    return get().then(function() {
      if (!vm.pixelKey) {
        return create();
      }
    });
  }

  function get() {
    if (CreativeService.creative.id) {
      return $http
        .get('/rtb_pixels/' + CreativeService.creative.id)
        .then(function(response) {
          if (response && response.data) {
            vm.pixelKey = response.data.pixelKey;
          }
        });
    } else {
      return $q.resolve();
    }
  }

  function adType() {
    switch (CreativeService.creative.action) {
      case 'hosted-video':
        return 'video';
      case 'video':
        return 'content-card';
      default:
        return 'display';
    }
  }

  function create() {
    return $http
      .post('/rtb_pixels', {
        previewId: CreativeService.creative.id,
        adType: adType()
      })
      .then(function(response) {
        vm.errors = null;
        vm.pixelKey = response.data.pixelKey;
      });
  }

  function reset() {
    vm.pixelKey = null;
    vm.errors = null;
  }
}

RtbPixelService.$inject = ['CreativeService', '$http', '$q'];
